import { useCallback } from "react";
import { useTranslate } from "@made-people/grease-translations";
import { FaqQnaItems } from "./faq-qna-items";
import { parseFaqItems } from "./parse-faq-items";
import { faqEventEmitter } from "./faq-event-emitter";
import type { Product } from "@made-people/grease-product";

export const ProductFaq = ({
  faq,
  product,
}: {
  faq: unknown;
  product: Product;
}) => {
  const translate = useTranslate();
  const items = parseFaqItems(faq);
  const handleQuestionOpen = useCallback(
    (question: string) => {
      faqEventEmitter.emit("faqClicked", {
        question,
        variant: "pdp",
        productSku: product.base.productKey,
        category: null,
      });
    },
    [product],
  );

  if (!items.length) return null;

  return (
    <div className="rounded-md px-6 py-10 col-start-1 col-span-12 lg:col-span-6 lg:row-start-10 mt-4 lg:mt-0 mb-2">
      <h2 className="font-secondary text-heading-md lg:text-heading-lg text-left pb-6 lg:pb-7">
        {translate("FAQ_title_pdp_plp")}
      </h2>
      <FaqQnaItems items={items} onQuestionOpen={handleQuestionOpen} />
    </div>
  );
};
